export const locationCookie = 'location';

export const deviceIdName = 'lmrvid';
